import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 13 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 13 8\" id=\"icon-down\">\r\n<style type=\"text/css\">\r\n\t#icon-down .st0{fill:#BBBBBB;}\r\n</style>\r\n<path class=\"st0\" d=\"M6.5,7.5C6.2,7.5,6,7.4,5.8,7.2l-5-5c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l4.3,4.3l4.3-4.3c0.4-0.4,1-0.4,1.4,0\r\n\ts0.4,1,0,1.4l-5,5C7,7.4,6.8,7.5,6.5,7.5z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol